import { Navigate, Route, Routes } from 'react-router-dom'
import { DashboardReportFolioRoutes } from '../pages/dashboard/routes'
import { NotificationCenter } from '../pages/notifications/pages/main'
import CatalogRoute from '../../service/pages/catalog/routes'
import TimeConfigRoutes from '../pages/timeConfig/routes'
import ReportSettingFolio from '../pages/setting/routes'

const ReportFolio = () => {
  return (
    <Routes>
      {/* DASHBOARD */}
      <Route index element={<Navigate to="/dashboard" />} />
      <Route path='dashboard/*' element={<DashboardReportFolioRoutes/>}/>
      <Route path="settings/*" element={<ReportSettingFolio />} />
      <Route path="notification" element={<NotificationCenter />} />
      <Route path="catalog/*" element={<CatalogRoute />} />
      <Route path="time-config/*" element={<TimeConfigRoutes />} />
    </Routes>
  )
}

export default ReportFolio
